/**
 * 占个坑
 * 预留一个日期口语化转换工具
 */
module.exports = {
  /**
   * 中文转换的对应文本
   */
  today: '今天',

  tomorrow: '明天',

  afterTomorrow: '后天',

  weekDay: ['日', '一', '二', '三', '四', '五', '六'],

  thisWeek: '本周',

  nextWeek: '下周',

  /**
   * 一天的时间增量
   */
  deltaT: 24 * 60 * 60 * 1000,

  /**
   * 获取输入时间当天的凌晨及星期
   * @param dt
   * @returns {{start: Date, end: Date, day: number}}
   */
  _getOneDayLimit: function (dt) {
    var day_str = this.formatDate(dt, 'YYYY/MM/DD'),
      day = dt.getDay();

    var start_time = day_str + ' 00:00:00',
      end_time = day_str + ' 23:59:59';

    return {
      start: new Date(start_time),
      end: new Date(end_time),
      day: day
    }
  },

  /**
   * 获取未来几周最后一天的凌晨
   * @param dt 当前日期
   * @param week 未来几周
   * @returns {*|{start, end, day}|{start: Date, end: Date, day: number}}
   * @private
   */
  _getWeekLimit: function (dt, week) {
    if (!week) week = 0;

    var day = dt.getDay(),
      week_delta = 7 - day + 7 * week, //本周剩余时间增量
      last_day = new Date(dt.getTime() + week_delta * this.deltaT);
    return this._getOneDayLimit(last_day);
  },

  /**
   * 将日期字符串装换成当天零点时间对象
   * @param str 输入字符串
   * @returns {Date} 当天零点时间对象
   */
  _convertDateStr: function (str) {
    //校验日期格式
    var regexp_cui = /^\d{4}-\d{2}-\d{2}$/,
      regexp_format = /^\d{4}\/\d{2}\/\d{2}$/;
    if (str.match(regexp_cui)) {
      str = str.replace(/-/g, '/');
    } else if (!str.match(regexp_format)) {
      throw new Error('输入日期' + str + '不符合日期格式YYYY-MM-DD或YYYY/MM/DD, 请检查!')
    }

    return new Date(str);
  },

  /**
   * 格式化时间
   * @param date 时间对象
   * @param fmt 格式类型 如:"YYYY-MM-DD"
   * @returns {*}
   */
  formatDate: function (date, fmt) {
    var o = {
      "M+": date.getMonth() + 1, //月份
      "D+": date.getDate(), //日
      "h+": date.getHours(), //小时
      "m+": date.getMinutes(), //分
      "s+": date.getSeconds(), //秒
      "q+": Math.floor((date.getMonth() + 3) / 3), //季度
      "S": date.getMilliseconds() //毫秒
    };
    if (/(Y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  },

  /**
   * 口语化转换
   * @param input 需要转换的日期
   * @returns {string}
   */
  toColloquial: function (input) {
    var resultText = '';

    if (typeof input == 'string') {
      input = this._convertDateStr(input);
      input = this._getOneDayLimit(input);
    } else if (input instanceof Date) {
      input = this._getOneDayLimit(input);
    } else {
      throw new Error('输入' + input + '不符合输入格式, 请输入Date类型对象或string字符串!')
    }

    var now = new Date(),
      today_limit = this._getOneDayLimit(now),
      week_limit = this._getWeekLimit(now, 0),
      next_week_limit = this._getWeekLimit(now, 1),
      today_delta = input.start - today_limit.start, //输入时间和今天的时间增量
      week_delta = input.start - week_limit.end,
      next_week_delta = input.start - next_week_limit.end;

    if (today_delta < 0) {
      //在今天之前
      resultText = this.formatDate(input.start, 'YYYY-MM-DD');
    } else if (week_delta < 0) {
      //在本周内
      if (today_delta < this.deltaT) {
        //在今天
        resultText = this.today;
      } else if (today_delta < this.deltaT * 2) {
        //在明天
        resultText = this.tomorrow;
      } else if (today_delta < this.deltaT * 3) {
        //在后天
        resultText = this.afterTomorrow;
      } else {
        resultText = this.thisWeek + this.weekDay[input.day];
      }
    } else if (next_week_delta < 0) {
      //在下周内
      resultText = this.nextWeek + this.weekDay[input.day];
    } else {
      resultText = this.formatDate(input.start, 'YYYY-MM-DD');
    }

    return resultText;
  }
}


// WEBPACK FOOTER //
// ./src/base/format.js